export default "__VITE_ASSET__Cygxf0nf__"